import React from 'react'

import { Modal } from '@/shared/ui'

import styles from './entity-products-modal.module.scss'

export type EntityProductsModalProps = {
	open: boolean
	onCancel: () => void
	onOk: () => void
	okText?: string
	cancelText?: string
}

/**
 * Modal for apply or cancel entity user type
 */
export const EntityProductsModal = ({
	open,
	onCancel,
	onOk,
	okText,
	cancelText
}: EntityProductsModalProps): JSX.Element => {
	return (
		<Modal
			isOpen={open}
			onClose={onCancel}
			onOk={onOk}
			okText={okText}
			cancelText={cancelText}
			contentClassName={styles.modal}>
			<p className={styles.description}>
				Выбранные услуги и акции для физических лиц будут удалены. <br /> Узнать подробности и оформить подходящие
				услуги для юридических лиц вы можете у оператора при подтверждении заказа.
			</p>
			<p className={styles.wideText}>Оформить заказ от юридического лица?</p>
		</Modal>
	)
}
